module.exports = "../images/boats.jpg?v=0f85c77";